<template>
  <div class="ma-4">
    <div class="text-h4 mb-2">Cadastro de Múltiplos Ramais</div>
    <v-tabs v-model="tabs" background-color="background">
      <v-tab v-for="n in tipos" :key="n">
        {{ tipo[n - 1] }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <AbaRamalPjsipMultiplos edicao="false" />
      </v-tab-item>
      <v-tab-item>
        <AbaRamalVirtualMultiplos edicao="false" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import AbaRamalPjsipMultiplos from '../_components/AbaRamalPjsipMultiplos'
import AbaRamalVirtualMultiplos from '../_components/AbaRamalVirtualMultiplos'

export default {
  name: 'CadastroMultiplosRamais',
  components: { AbaRamalVirtualMultiplos, AbaRamalPjsipMultiplos },
  data: () => ({
    tipos: 2,
    tab: null,
    tabs: 2,
    tipo: ['PJSIP', 'Virtual'],
  }),
}
</script>
